<script setup lang="ts">
	import DataList from '../../../views/owner/components/DataList/index.vue';
	import DataTerm from '../../../views/owner/components/DataTerm/index.vue';
	import DataValue from '../../../views/owner/components/DataValue/index.vue';
	import { positionList, paymentList, planList } from '~/models/enums';

	const store = useOwnerRegisterStore();
	const { formOneData, formTwoData } = store;

	const getPositionObject = (id: number): string => {
		let item = positionList.find((u: any) => u.value == id)
		if(item) {
			return item.label
		}
		return ''
	}

	const getPaymentObject = (id: number): string => {
		let item = paymentList.find((u: any) => u.value == id)
		if(item) {
			return item.label
		}
		return ''
	}
</script>

<template>
	<Block class="mt-[2.4rem] border-[lightGray] border-[.1rem] py-[2.4rem] flex flex-col justify-center items-center rounded-[.8rem]">
		<Block class="max-w-[84rem] w-full mx-auto">
			<TitleText
				class="text-center"
				type="4"
			>
				Confirmation
			</TitleText>

			<Block>
				<!-- Customer Information -->
				<Block class="mt-[2.4rem]" v-if="formOneData">
					<TitleText type="6">
						Customer Information
					</TitleText>
					<Block class="border-t-[.1rem] border-t-[lightGray] mt-[1.7rem] w-full">
						<DataList>
							<DataTerm>Full Name</DataTerm>
							<DataValue v-if="formOneData.firstname && formOneData.lastname">
								<p>{{ formOneData.firstname }} {{ formOneData.lastname }}</p>
							</DataValue>
						</DataList>

						<DataList>
							<DataTerm>Date of Birth</DataTerm>
							<DataValue v-if="formOneData.birthday">
								<p>{{ dateFormat(formOneData.birthday, 'date') }}</p>
							</DataValue>
						</DataList>

						<DataList>
							<DataTerm>Email Address</DataTerm>
							<DataValue v-if="formOneData.email">
								<p>{{ formOneData.email }}</p>
							</DataValue>
						</DataList>

						<DataList>
							<DataTerm>Phone Number</DataTerm>
							<DataValue v-if="formOneData.contact">
								<p>{{ formOneData.contact }}</p>
							</DataValue>
						</DataList>
					</Block>
				</Block>

				<!-- Store Information -->
				<Block class="mt-[2.4rem]" v-if="formTwoData">
					<TitleText
						type="6"
					>
						Store Information
					</TitleText>
					<Block class="border-t-[.1rem] border-t-[lightGray] mt-[1.7rem] w-full">
						<DataList>
							<DataTerm>Store Name</DataTerm>
							<DataValue v-if="formTwoData.name">
								<p>{{ formTwoData.name }}</p>
							</DataValue>
						</DataList>

						<DataList>
							<DataTerm>Address</DataTerm>
							<DataValue v-if="formTwoData.address1">
								<p>{{ formTwoData.address1 }}</p>
							</DataValue>
						</DataList>

						<DataList>
							<DataTerm>City/State</DataTerm>
							<DataValue v-if="formTwoData.city_id && formTwoData.region_id">
								<p>{{ formTwoData.city_id.label }}, {{ formTwoData.region_id.label }}</p>
							</DataValue>
						</DataList>

						<DataList>
							<DataTerm>Category</DataTerm>
							<DataValue v-if="formTwoData.categories">
								<p>
									<span :key="index" v-for="category, index in formTwoData.categories">
										{{  category.label }}{{ (index == formTwoData.categories.length-1) ? '' : ', ' }}
									</span>
								</p>
							</DataValue>
						</DataList>

						<!-- <DataList>
							<DataTerm>Position</DataTerm>
							<DataValue v-if="formTwoData.position">
								<p>{{ getPositionObject(formTwoData.position) }}</p>
							</DataValue>
						</DataList> -->

						<DataList>
							<DataTerm>Store Phone Number</DataTerm>
							<DataValue v-if="formTwoData.contact">
								<p>{{ formTwoData.contact }}</p>
							</DataValue>
						</DataList>

						<DataList>
							<DataTerm>Plan Type</DataTerm>
							<DataValue v-if="formTwoData.planType">
								<p>{{ formTwoData.planType.label }}</p>
							</DataValue>
						</DataList>
					</Block>
				</Block>

				<!-- Credit Card Information -->
				<Block class="mt-[2.4rem]" v-if="formTwoData && formTwoData.planType && formTwoData.planType.value !== 1">
					<TitleText
						type="6"
					>
						Credit Card Information
					</TitleText>
					<Block class="border-t-[.1rem] border-t-[lightGray] mt-[1.7rem] w-full">
						<!-- <DataList>
							<DataTerm>Payment Method</DataTerm>
							<DataValue v-if="formTwoData.paymentMethod">
								<p>{{ getPaymentObject(formTwoData.paymentMethod) }}</p>
							</DataValue>
						</DataList> -->

						<DataList>
							<DataTerm>Credit Card Number</DataTerm>
							<DataValue v-if="formTwoData.card_number">
								<p>{{ formTwoData.card_number }}</p>
							</DataValue>
						</DataList>

						<DataList>
							<DataTerm>Expiry Date</DataTerm>
							<DataValue v-if="formTwoData.exp_month && formTwoData.exp_year">
								<p>{{ dateFormat(formTwoData.exp_month, 'month') }} /  {{ dateFormat(formTwoData.exp_year, 'year') }}</p>
							</DataValue>
						</DataList>

						<DataList>
							<DataTerm>Cardholder's name</DataTerm>
							<DataValue v-if="formTwoData.card_holder_name">
								<p>{{ formTwoData.card_holder_name }}</p>
							</DataValue>
						</DataList>

						<DataList>
							<DataTerm>Security Code</DataTerm>
							<DataValue v-if="formTwoData.cvc">
								<p>{{ formTwoData.cvc }}</p>
							</DataValue>
						</DataList>
					</Block>
				</Block>
			</Block>
		</Block>
	</Block>
</template>
